import type { RouteObject } from "react-router-dom";
import { HomePage } from "./HomePage";

export const routes: RouteObject[] = [{ path: "home", element: <HomePage /> }];
